import { render, staticRenderFns } from "./CreatorCenterSidebar.vue?vue&type=template&id=53e9940b&scoped=true&"
import script from "./CreatorCenterSidebar.vue?vue&type=script&lang=js&"
export * from "./CreatorCenterSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CreatorCenterSidebar.vue?vue&type=style&index=0&id=53e9940b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9940b",
  null
  
)

export default component.exports